import React from "react";
import { sendReattach } from "./useTearoffBridge";

/**
 * TearoffBar — rendered at the top of every tearoff (detached) window.
 *
 * Gives the user:
 *  1. A clear label that this is a detached view
 *  2. A "Pop Back In" button to reattach it to the main webtop
 *
 * Reattach path:
 *  - sendReattach broadcasts via BroadcastChannel (web + Electron)
 *  - webtopPopIn sends an Electron IPC to the main process (Electron only)
 *    which notifies the main window renderer directly
 *  - window.close() closes this OS window
 */
const TearoffBar = ({ path, title }) => {
  const handlePopIn = () => {
    // Broadcast to the main window (works in both web and Electron)
    sendReattach(path, title);

    // Electron IPC fallback: notifies main process directly
    window.electronAPI?.webtopPopIn?.({ path, title });

    window.close();
  };

  return (
    <div className="webtop-tearoff-bar">
      <svg
        className="webtop-tearoff-bar__icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden="true"
      >
        <rect x="1" y="1" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.2" />
        <path d="M5 7h4M7 5v4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
      <span className="webtop-tearoff-bar__label">
        Detached window — drag to any monitor
      </span>
      <button
        type="button"
        className="webtop-tearoff-bar__popin"
        onClick={handlePopIn}
      >
        ↩ Pop Back In
      </button>
    </div>
  );
};

export default TearoffBar;
